import React, {PureComponent} from "react"
import PropTypes from "prop-types"
import {IntlProvider, addLocaleData} from "react-intl"
import en from "react-intl/locale-data/en"
import fr from "react-intl/locale-data/fr"
import {connect} from "@irati/store"
import {Auth} from "@irati/auth/types"

import authentication from "@irati/auth"
import getKey from "./helpers/getKey"
import getSupportedLocale from "./helpers/getSupportedLocale"

addLocaleData([...en, ...fr])

interface Props {
  auth: Auth
  lang: any
}

class LangProvider extends PureComponent<Props> {
  static propTypes = {
    lang: PropTypes.object.isRequired,
    auth: PropTypes.object.isRequired
  }

  render() {
    const {lang} = this.props
    const messages = lang.messages || {}
    const locale = getSupportedLocale(authentication.userLocale())

    return (
      <IntlProvider
        {...this.props}
        locale={locale}
        key={getKey({locale, messages})}
        messages={messages}
        onError={(error) => {
          console.log(error)
        }}
      />
    )
  }
}

/** @desc: need auth to make sure this re-renders on any auth changes although not directly used */
const mapStateToProps = ({lang, auth}: {lang: any; auth: Auth}) => ({lang, auth})

export default connect(mapStateToProps)(LangProvider)
